module.exports = new __parcel__URL__("leaderboard_pve_button.a8345f38.png").toString();